<script>
  import marked from 'marked';

  export let content;

  const renderer = new marked.Renderer();

  // shouldn't be declared as arrow function because of using 'this' keyword
  renderer.link = function(href, title, text) {
    const link = marked.Renderer.prototype.link.call(this, href, title, text);
    return link.replace("<a",'<a class="clickable" target="_blank" onclick="event.stopPropagation();" ');
  };


  marked.setOptions({
    renderer: renderer
  });

</script>

<div class="markdown">
    {@html marked(content.replace(/\n\n/g, '<br />'))}
</div>


<style>
  .markdown {
    line-height: 1.5em;
    word-break: break-all;
  }

  /* need to be set as global since element is included in the html string */
  :global(.markdown p) {
    white-space: pre-wrap;
  }

  :global(.markdown blockquote) {
    border-left: 4px solid #ccc;
    padding: 0 8px;
  }

  :global(.markdown a) {
    color: #555;
    text-decoration: underline;
  }

  :global(.markdown li) {
    list-style: disc;
    text-indent: 24px;
  }

  :global(.markdown hr) {
    height: 0;
    border: none;
    border-top: 1px solid #555;
  }
</style>